module.exports = __webpack_public_path__ + "images/emoji/truck.63690062cb944e2174d5.png";